<template>
  <div class="main">
    <iframe
      allowfullscreen
      id="aliyunPreview"
      frameborder="0"
      scrolling="yes"
      src="http://preview.imm.aliyun.com/index.html"
      style=" height:100%"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: ["url", "urlParams"],
  components: {},
  data() {
    return {};  
  },

  mounted() {
    var _this = this;
    window.addEventListener(
      "message",
      function(e) {
        try {
          var res = JSON.parse(e.data);
        } catch (err) {
          return;
        }
        switch (res.action) {
          case "preview.ready":
            _this.sendMessage("preview.init", _this.url);
            break;
        }
      },
      false
    );

    document.addEventListener("gesturestart", function(e) {
      e.preventDefault();
    });

    document.addEventListener(
      "fullscreenchange",
      function() {
        this.setFullScreenState(!!document.fullscreen);
      },
      false
    );
  },
  methods: {
    json2str(obj) {
      return JSON.stringify(obj, function(key, val) {
        if (typeof val === "function") {
          val = val.toString();
        }
        return val;
      });
    },
    setFullScreenState(state) {
      // state true: 全屏状态 false： 退出全屏状态
      console.log("状态w为" + state);
      this.sendMessage("logic.fullscreenchange", { state: state });
    },
    fullScreen() {
      console.log("点击放大");
      var el = document.getElementById("aliyunPreview");
      var fn =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      fn.call(el);
    },
    sendMessage(action, data) {
      console.log(action, data);
      let _this = this;
      if (action == "preview.init") {
        var iframe = document.getElementById("aliyunPreview");
        iframe.contentWindow.postMessage(
          _this.json2str({ action: action, data: data }),
          "*"
        );
      } 
    },
  }
};
</script>


<style  scoped lang="less">
.main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#aliyunPreview {
  width: 100%;
  height: 100%;
}
</style>



